import axios from 'axios';
import * as config from './config';
import * as util from './util';
import { NordicTracking } from './util/analytics';
import { PuzzelClient } from './clients/puzzel';
import * as ifhelp2015api from './ifhelp2015api';
import { showPanel } from './show-panel';
import { getHourInNordics } from './util/time';
import { showIfGPT } from './show-ifgpt';

const applyToggles = (next) => {
    const iimclient = window.iimclient;
    if (!iimclient) {
        next();
        return;
    }

    const language = (iimclient.lang ? iimclient.lang.replace(/^lang_/, '') : 'en').toUpperCase();

    ifhelp2015api
        .initializeFeatureTogglesPromise()
        .then(() => {
            if (ifhelp2015api.getFeatureToggle('HideContactPanel' + language)) {
                iimclient.hidePanel = true;
            }

            if (ifhelp2015api.getFeatureToggle('HideCallback' + language)) {
                iimclient.hideCallback = true;
            }

            if (ifhelp2015api.getFeatureToggle('HideCall' + language)) {
                iimclient.hidePhoneBox = true;
            }

            if (ifhelp2015api.getFeatureToggle('HideChat' + language)) {
                iimclient.hideChatBox = true;
            }

            next();
        })
        .catch(() => {
            next();
        });
};

const applyMobilityStyles = () => {
    const iimclient = window.iimclient;
    if (!iimclient) return;

    const mypath = iimclient.mypath;
    if (!mypath) return;

    const isMobilityPage = window.ifhelp2015api.isMobilityPagesUrl();
    if (isMobilityPage) {
        const link = document.createElement('link');
        link.type = 'text/css';
        link.rel = 'stylesheet';
        link.href = mypath + 'mobility.css';
        document.head.appendChild(link);
        iimclient.mobility = true;
    }
};

const ifhelp = () => {
    'use strict';
    if (!String.prototype.endsWith) {
        String.prototype.endsWith = function (search, this_len) {
            if (this_len === undefined || this_len > this.length) {
                this_len = this.length;
            }
            return this.substring(this_len - search.length, this_len) === search;
        };
    }

    if (!window.NordicTracking) window.NordicTracking = NordicTracking();
    if (!window.PuzzelClient) window.PuzzelClient = PuzzelClient();
    if (typeof window.iimclient === 'undefined') {
        window.iimclient = {};

        const scriptFullPath = util.getScriptFullPath();
        config.getConfigFromContext(scriptFullPath, window.location).then((iimclient) => {
            if (iimclient === null) return;

            window.iimclient = iimclient;
            iimclient.config = {};
            Object.keys(iimclient).forEach((key) => {
                iimclient.config[key] = iimclient[key];
            });

            iimclient.myfullpath = scriptFullPath;
            iimclient.mypath = util.getScriptOrigin() || '';

            const mypath = iimclient.mypath;
            const myfullpath = iimclient.myfullpath;

            const hasSessionStorage = util.hasSessionStorage();

            const minimizeFloaterForURLs = [
                '/privat/kundeservice/skriv-til-oss/omskade',
                '/privat/kundeservice/skriv-til-oss/omforsikring',
            ];

            const minimizeChatForURLs = [
                'yritysasiakkaat/ota-yhteytta/soittopyyntolomake',
                'henkiloasiakkaat/asiakaspalvelu/soittopyyntolomake',
                'localhost:3000/wcb-fi',
            ];

            if (ifhelp2015api.containsHash('murl')) {
                window.location.hash = window.location.hash.replace('murl', '');
                minimizeChatForURLs.push(ifhelp2015api.getPageURL());
            }

            const hideCallbackForURLs = [
                'yritysasiakkaat/ota-yhteytta/soittopyyntolomake',
                'henkiloasiakkaat/asiakaspalvelu/soittopyyntolomake',
            ];

            iimclient.isMobile = !!navigator.userAgent.match(
                /(iPhone)|(iPod)|(webOS)|(Windows Phone)|(WPDesktop)/i
            );
            if (!iimclient.isMobile) {
                // Android phones should have "Mobile Safari" in ua string and tablets should have only Safari.
                iimclient.isMobile = !!(
                    navigator.userAgent.match(/Android/i) && navigator.userAgent.match(/Mobile/i)
                );
            }

            iimclient.isTablet =
                !iimclient.isMobile &&
                !!(navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/Android/i));

            iimclient.now = new Date();
            iimclient.printDebug = /test|127\.0\.0\.1|localhost/.test(mypath) ? true : false;
            const day = iimclient.now.getUTCDay();
            let hour = getHourInNordics(iimclient.now);

            let callbackOK = 'En kunderådgiver vil ringe<br />deg om kort tid.';
            let avgWaitTime = 'Ventetid nå: ';

            iimclient.testURLMapping =
                util.getQueryParameterFromUrl('test-url-mapping') ||
                util.getFromSessionStorage('testURLMapping')
                    ? true
                    : false;

            if (hasSessionStorage) {
                if (iimclient.testURLMapping && !window.sessionStorage.getItem('testURLMapping')) {
                    window.sessionStorage.setItem('testURLMapping', 1);
                }
            }

            iimclient.chatInitialized = false;

            if (iimclient.myfullpath.indexOf('segmentid=') > -1) {
                if (
                    iimclient.myfullpath
                        .substr(iimclient.myfullpath.indexOf('segmentid='))
                        .split('&')[0]
                        .split('=')[1] &&
                    !iimclient.segmentId
                ) {
                    iimclient.segmentId = decodeURIComponent(
                        iimclient.myfullpath
                            .substr(iimclient.myfullpath.indexOf('segmentid='))
                            .split('&')[0]
                            .split('=')[1]
                    );
                }
            }

            if (iimclient.myfullpath.indexOf('callback-bindtoid=') > -1) {
                if (
                    iimclient.myfullpath
                        .substr(iimclient.myfullpath.indexOf('callback-bindtoid='))
                        .split('&')[0]
                        .split('=')[1] &&
                    !iimclient.webcallback.bindToID
                ) {
                    iimclient.webcallback.bindToID = decodeURIComponent(
                        iimclient.myfullpath
                            .substr(iimclient.myfullpath.indexOf('callback-bindtoid='))
                            .split('&')[0]
                            .split('=')[1]
                    );
                }
            }

            if (iimclient.myfullpath.indexOf('pageurl=') > -1) {
                if (
                    iimclient.myfullpath
                        .substr(iimclient.myfullpath.indexOf('pageurl='))
                        .split('&')[0]
                        .split('=')[1] &&
                    !iimclient.pageURL
                ) {
                    iimclient.pageURL = decodeURIComponent(
                        iimclient.myfullpath
                            .substr(iimclient.myfullpath.indexOf('pageurl='))
                            .split('&')[0]
                            .split('=')[1]
                    );
                }
            }

            if (iimclient.myfullpath.indexOf('usesegment=') > -1) {
                if (
                    iimclient.myfullpath
                        .substr(iimclient.myfullpath.indexOf('usesegment='))
                        .split('&')[0]
                        .split('=')[1] &&
                    !iimclient.useSegment
                ) {
                    iimclient.useSegment =
                        decodeURIComponent(
                            iimclient.myfullpath
                                .substr(iimclient.myfullpath.indexOf('usesegment='))
                                .split('&')[0]
                                .split('=')[1]
                        ) == '1'
                            ? true
                            : false;
                }
            }

            if (iimclient.myfullpath.indexOf('callisclosed=') > -1) {
                if (
                    iimclient.myfullpath
                        .substr(iimclient.myfullpath.indexOf('callisclosed='))
                        .split('&')[0]
                        .split('=')[1] &&
                    !iimclient.callIsClosed
                ) {
                    iimclient.callIsClosed =
                        decodeURIComponent(
                            iimclient.myfullpath
                                .substr(iimclient.myfullpath.indexOf('callisclosed='))
                                .split('&')[0]
                                .split('=')[1]
                        ) == '1'
                            ? true
                            : false;
                }
            }

            // test
            if (mypath === '' || iimclient.printDebug) {
                if (iimclient.myfullpath.indexOf('hour=') > -1) {
                    if (
                        iimclient.myfullpath
                            .substr(iimclient.myfullpath.indexOf('hour='))
                            .split('&')[0]
                            .split('=')[1]
                    ) {
                        hour = decodeURIComponent(
                            iimclient.myfullpath
                                .substr(iimclient.myfullpath.indexOf('hour='))
                                .split('&')[0]
                                .split('=')[1]
                        );
                        //console.log(hour);
                    }
                }
            }

            const getWillOpenText = (iimclient.getWillOpenText = function () {
                let willOpenText = '08:00';
                if (iimclient.lang == 'lang_no') {
                    if (iimclient.novertikal) willOpenText = '09:00';
                    if ((day === 5 && hour >= 21) || (day === 6 && hour < 9)) {
                        // friday evening / saturday morning
                        willOpenText = '09:00';
                    }
                    if ((day === 6 && hour >= 17) || (day === 0 && hour < 12)) {
                        // saturday evening / sunday morning
                        willOpenText = '12:00';
                    }
                    // easter exceptions
                    if (
                        iimclient.now > new Date(Date.parse('Wed, 08 Apr 2020 20:00:00 GMT+2')) &&
                        iimclient.now < new Date(Date.parse('Sat, 11 Apr 2020 09:00:00 GMT+2'))
                    ) {
                        willOpenText = '09:00 11. april';
                    }
                    if (
                        iimclient.now > new Date(Date.parse('Wed, 11 Apr 2020 15:00:00 GMT+2')) &&
                        iimclient.now < new Date(Date.parse('Mon, 13 Apr 2020 23:59:59 GMT+2'))
                    ) {
                        willOpenText = '08:00 14. april';
                    }
                }

                if (iimclient.lang == 'lang_dk') {
                    if ((day === 5 && hour >= 18) || (day === 6 && hour < 10)) {
                        // friday evening / saturday morning
                        willOpenText = '10:00';
                    }
                    if ((day === 6 && hour >= 16) || (day === 0 && hour < 10)) {
                        // saturday evening / sunday morning
                        willOpenText = '10:00';
                    }
                }
                return willOpenText;
            });

            const loadIFHelp = function () {
                iimclient.texts = {
                    'back-button': 'Tilbake',
                    'callback-not-available':
                        'Beklager, men det er ikke mulig å legge igjen en callback nå.',
                    'call-menu-item-header': 'Ring',
                    'call-menu-item-description': 'Ring til oss eller bli oppringt.',
                    'call-menu-item-button': 'Ring',
                    'email-menu-item-header': 'Skriv',
                    'email-menu-item-description': 'Skriv til oss.',
                    'email-menu-item-button': 'Skriv',
                    'call-name-placeholder': 'Ditt navn',
                    'call-header': 'Ring',
                    'call-number': {
                        visual: '21 49 24 00',
                        link: '+4721492400',
                    },
                    'call-callback-description':
                        'Vi ringer deg opp ved spørsmål om alt som har med forsikringene dine å gjøre, unntatt skade. Ved skade, ring<br /><a class="styleless tel" href="tel:+4721492400" role="link" onclick="window.NordicTracking.eventPhoneLink(false, window.NordicTracking.PANELINFO_FUNCTION_NAME_PHONE, \'+4721492400\');">21 49 24 00</a>.',
                    'call-queue-description': '',
                    'call-callback-start': 'Bli oppringt',
                    'call-isclosed': '', //'Kundeservice er nå stengt.',
                    'call-schedule-text':
                        '<div><a href="https://www.if.no/privat/kundeservice/kontakt-oss#apningstider" role="link">Åpningstider privatkunder</a></div><p><a href="https://www.if.no/bedrift/kundeservice" role="link">Åpningstider bedriftskunder</a></p>',
                    closed: 'Stengt',
                    // close: 'Lukk',
                    close: iimclient.ariaLabels['close'],
                    days: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
                    'email-header': 'Skriv til oss',
                    'email-claim-button': 'Om skade',
                    'email-other-button': 'Andre henvendelser',
                    error: 'Det oppstod en feil',
                    technicalProblem: 'Teknisk problem.',
                    callbackOK: callbackOK,
                    fewSeconds: 'noen sekunder',
                    oneMinute: 'ett minutt',
                    minutes: 'minutter',
                    oneHour: 'en time',
                    twoHours: 'to timer',
                    hours: 'timer',
                    avgWaitTime: avgWaitTime,
                    loadingChat: 'Laster chat...',
                    email: 'E-post',
                };

                if (!(iimclient && iimclient.textlang)) iimclient.textlang = iimclient.lang;

                if (iimclient.textlang === 'lang_se') {
                    iimclient.texts = {
                        'back-button': 'Tillbaka',
                        'email-header': 'Skriv till oss',
                        'callback-not-available':
                            'Sorry, but it is not possible to leave a callback now.',
                        'hideshow-icon-title': 'Visa/dölj',
                        'call-menu-item-header': 'Ring',
                        'call-menu-item-description': 'Ring till oss eller bli uppringd.',
                        'call-menu-item-button': 'Ring',
                        'email-menu-item-header': 'Skriv',
                        'email-menu-item-description': 'Skriv till oss.',
                        'email-menu-item-button': 'Skriv',
                        'call-name-placeholder': 'Ditt namn',
                        'call-header': 'Ring',
                        //'call-queue-description': 'Bli uppringd när det är kö.',
                        'call-callback-start': 'Bli uppringd',
                        'call-isclosed': '', //'Kundservice är nu stängd.',
                        'call-schedule-text':
                            '<div><a href="https://www.if.se/privat/kundservice#oppet" role="link">Öppettider privat</a></div><p><a href="https://www.if.se/foretag/kundservice" role="link">Öppettider företag</a></p>',
                        closed: 'Stängt',
                        // close: 'Stäng',
                        close: iimclient.ariaLabels['close'],
                        days: [
                            'söndag',
                            'måndag',
                            'tisdag',
                            'onsdag',
                            'torsdag',
                            'fredag',
                            'lördag',
                        ],
                        error: 'Ett fel inträffade',
                        technicalProblem: 'Teknisk problem.',
                        callbackOK: 'Din återuppringning är nu beställd. Vi spelar in samtalet.',
                        fewSeconds: 'några sekunder',
                        oneMinute: '1 minut',
                        minutes: 'minuter',
                        oneHour: '1 timme',
                        twoHours: '2 timmar',
                        hours: 'timer',
                        avgWaitTime: 'Väntetiden är nu ',
                        loadingChat: 'Laddar ...', // "Laddar chat" caused break line
                        email: 'Mejl',
                    };
                    if (
                        /\?sepriv/.test(myfullpath) ||
                        /\?seprivverkstadschatt/.test(myfullpath) ||
                        /\?seanimal/.test(myfullpath) ||
                        /\?sebreeders/.test(myfullpath)
                    ) {
                        iimclient.texts['call-callback-description'] =
                            'Vi ringer upp dig inom våra <a href="https://www.if.se/privat/kundservice#oppet" role="link" style="margin-right: 0px">öppettider</a>.';
                        iimclient.texts['call-callback-start'] = 'Ring upp mig';
                        iimclient.texts['call-callback-start2'] = 'Ring mig';
                        iimclient.texts['call-header'] = 'Ring';
                        iimclient.texts['callback-not-available'] =
                            'Just nu kan du inte bli uppringd.';
                        //When implemented, change to this: iimclient.texts['callback-not-available'] = 'Vår återuppringsningsfunktion är just nu stängd men du kan välja en möjlig tid i kalendern';
                        iimclient.texts['callback-name-validationerror'] =
                            'Du måste fylla i detta fält';
                        iimclient.texts['callback-selectedqueue-validationerror'] =
                            'Du måste välja ett ärende';
                    }
                    if (
                        /\?secom/.test(myfullpath) ||
                        /\?secombroker/.test(myfullpath) ||
                        /\?secomclaims/.test(myfullpath) ||
                        /\?secommotorclaims/.test(myfullpath)
                    ) {
                        iimclient.texts['email-header'] = 'Mejla oss';
                        iimclient.texts['email-claim-button'] = 'Skicka mejl';
                        iimclient.texts['call-callback-description'] = 'Bli uppringd';
                        iimclient.texts['call-callback-start'] = 'Ring mig';
                        iimclient.texts['callback-not-available'] =
                            'Just nu kan du inte bli uppringd.';
                        //When implemented, change to this: iimclient.texts['callback-not-available'] = 'Vår återuppringsningsfunktion är just nu stängd men du kan välja en möjlig tid i kalendern';
                    }
                } else if (iimclient.textlang === 'lang_dk') {
                    iimclient.texts = {
                        // close: 'Lukk',
                        close: iimclient.ariaLabels['close'],
                        'back-button': 'Tilbage',
                        'callback-not-available':
                            'Beklager, men det er ikke muligt at forlade en tilbagekald nu.',
                        'hideshow-icon-title': 'Vis/Skjul',
                        'call-icon-title': 'Ring til Kundeservice',
                        'email-icon-title': 'Skriv til os',
                        'call-menu-item-header': 'Ring',
                        'call-menu-item-description': 'Ring til Kundeservice eller bestil opkald.',
                        'call-menu-item-button': 'Ring',
                        'email-menu-item-header': 'Skriv',
                        'email-menu-item-description': 'Skriv til os.',
                        'email-menu-item-button': 'Skriv',
                        'call-name-placeholder': 'Dit navn',
                        'call-header': 'Ring til Kundeservice',
                        'call-callback-header': 'Bestil opkald',
                        'call-queue-description': '<span class="heading">Bestil opkald</span>',
                        'call-callback-start': 'Hvornår skal vi ringe?',
                        'call-callback-start2': 'Bestil opkald',
                        'call-isclosed': '', //'Kundecenteret er lukket',
                        'call-schedule-text':
                            '<a href="https://www.if.dk/privat/kontakt#tider" role="link">Åbningstider</a>',
                        /*Check*/ closed: 'Lukket',
                        days: [
                            'Søndag',
                            'Mandag',
                            'Tirsdag',
                            'Onsdag',
                            'Torsdag',
                            'Fredag',
                            'Lørdag',
                        ],
                        'email-header': 'Skriv til os',
                        'email-claim-button': 'Mail til Kundeservice',
                        /*Not used, only one button for DK*/ 'email-other-button':
                            'Andre henvendelser',
                        error: 'Der opstod en fejl',
                        technicalProblem: 'Teknisk problem.',
                        callbackOK: 'Du vil blive ringet op hurtigst muligt',
                        fewSeconds: 'nogle sekunder',
                        oneMinute: '1 minut',
                        minutes: 'minutter',
                        oneHour: '1 time',
                        twoHours: '2 timer',
                        hours: 'timer',
                        avgWaitTime: 'Ventetiden er nu: ',
                        loadingChat: 'Indlæser chat...',
                        'call-callback-number-placeholder': 'Indtast dit telefonnummer',
                        email: 'Mail',
                    };
                    if (/\?dkcom/.test(myfullpath)) {
                        // Some texts differ from priv
                        iimclient.texts['call-icon-title'] = 'Ring til os';
                        iimclient.texts['call-header'] = 'Ring til os';
                        iimclient.texts['call-schedule-text'] =
                            'Vi er tilstede man - tor kl. 8 - 17 og fre 8 - 16';
                        iimclient.texts['call-queue-description'] = '';
                        iimclient.texts['call-callback-start'] = 'Bestil telefonmøde';
                        iimclient.texts['email-icon-title'] = 'Mail os';
                        iimclient.texts['email-header'] = 'Mail os';
                        iimclient.texts['email-claim-button'] = 'Send en mail';
                        iimclient.texts['call-isclosed'] = '';
                    } else if (/\?dkkvalitet/.test(myfullpath)) {
                        iimclient.texts['call-header'] = 'Ring om Betaling';
                        iimclient.texts['call-header2'] = 'Ring om Boet efter/Sanering';
                        iimclient.texts['email-claim-button'] = 'Mail til UW Kvalitet';
                    } else if (/\?dksalessupport/.test(myfullpath)) {
                        iimclient.texts['call-icon-title'] = 'Ring til Salessupport';
                        iimclient.texts['call-header'] = 'Ring til<br/>Salessupport';
                        iimclient.texts['email-claim-button'] = 'Mail til Salessupport';
                    } else {
                        // dkpriv + dkprivwebshop
                        iimclient.texts['email-description'] =
                            'Skriv til os sikkert via Mine Sider.';
                        iimclient.texts['email-claim-button'] = 'Skriv besked';
                    }
                } else if (iimclient.textlang === 'lang_fi') {
                    iimclient.texts = {
                        'back-button': 'Takaisin',
                        'callback-not-available':
                            'Pahoittelut, mutta soittopyynnön jättäminen ei ole tällä hetkellä mahdollista',
                        'hideshow-icon-title': 'Näytä/Piilota',
                        'call-icon-title': 'Soita meille',
                        'email-icon-title': 'Kirjoita meille',
                        'call-menu-item-header': 'Soita',
                        'call-menu-item-description':
                            'Soita asiakaspalveluumme tai jätä soittopyyntö.',
                        'call-menu-item-button': 'Soita',
                        'email-menu-item-header': 'Kirjoita',
                        'email-menu-item-description': 'Kirjoita meille.',
                        'email-menu-item-button': 'Kirjoita',
                        'call-name-placeholder': 'Sinun nimesi',
                        'call-header': 'Soita',
                        //'call-queue-description': 'Jos jono on pitkä, voit jättää meille soittopyynnön',
                        'call-callback-start': 'Jätä soittopyyntö',
                        'call-isclosed': 'Asiakaspalvelu on nyt suljettu.',
                        'callback-selectedqueue-validationerror': 'Aihe pitää valita',
                        'callback-phonenumber-validationerror': 'Anna puhelinnumero',
                        closed: 'Suljettu',
                        // close: 'Sulje',
                        close: iimclient.ariaLabels['close'],
                        days: [
                            'Sunnuntai',
                            'Maanantai',
                            'Tiistai',
                            'Keskiviikko',
                            'Torstai',
                            'Perjantai',
                            'Lauantai',
                        ],
                        'email-header': 'Kirjoita meille',
                        'email-claim-button': 'Kirjoita',
                        'email-other-button': 'Muut tiedustelut',
                        error: 'Tapahtui virhe',
                        technicalProblem: 'Tekninen ongelma',
                        callbackOK: 'Soittopyynnön jättäminen onnistui',
                        fewSeconds: 'muutama sekunti',
                        oneMinute: '1 minuutti',
                        minutes: 'minuutit',
                        oneHour: '1 tunti',
                        twoHours: '2 tuntia',
                        hours: 'tunnit',
                        avgWaitTime: 'Keskimääräinen odotusaika ',
                        loadingChat: 'Lataa chattia',
                        email: 'E-mail',
                    };
                } else if (iimclient.textlang === 'lang_en') {
                    avgWaitTime = 'Waiting time now: ';
                    iimclient.texts = {
                        'back-button': 'Previous',
                        'callback-not-available': 'Sorry, callback is no longer available-',
                        'hideshow-icon-title': 'Hide/Show',
                        'call-icon-title': 'Call',
                        'email-icon-title': 'Email',
                        'call-menu-item-header': 'Call',
                        'call-menu-item-description': 'Call or ask to call you back.',
                        'call-menu-item-button': 'Call',
                        'email-menu-item-header': 'Email',
                        'email-menu-item-description': 'Email us.',
                        'email-menu-item-button': 'Email',
                        'call-name-placeholder': 'Your name',
                        'call-header': 'Call',
                        'call-callback-description': 'We call you back',
                        'call-queue-description': '',
                        'call-callback-start': 'Call me back',
                        'call-isclosed':
                            'Customer service is now closed.<br />Opens at ' +
                            getWillOpenText() +
                            '.<br /><br />Have you received a claim or needhelp immediately, you can call us 24/7.',
                        closed: 'Closed',
                        // close: 'Close',
                        close: iimclient.ariaLabels['close'],
                        days: [
                            'Sunday',
                            'Monday',
                            'Tuesday',
                            'Wednesday',
                            'Thursday',
                            'Friday',
                            'Saturday',
                        ],
                        'email-header': 'Write to us',
                        'email-claim-button': 'Write email',
                        'email-other-button': 'Other requests',
                        error: 'An error occured',
                        technicalProblem: 'Techical issue.',
                        callbackOK: callbackOK,
                        fewSeconds: 'A few seconds',
                        oneMinute: 'One minute',
                        minutes: 'Minutes',
                        oneHour: 'An hour',
                        twoHours: 'Two hours',
                        hours: 'Hours',
                        avgWaitTime: avgWaitTime,
                        loadingChat: 'Loading chat...',
                        email: 'E-mail',
                    };
                }
                // Country specific texts regardless of text language
                if (iimclient.lang === 'lang_se') {
                    iimclient.texts['call-number'] = {
                        visual: '10 19 19 19',
                        link: '+35810191919',
                    };
                    if (
                        /\?sepriv/.test(myfullpath) ||
                        /\?seprivverkstadschatt/.test(myfullpath) ||
                        /\?seanimal/.test(myfullpath) ||
                        /\?sebreeders/.test(myfullpath)
                    ) {
                        if (/\?seprivverkstadschatt/.test(myfullpath)) {
                            iimclient.texts['call-number'] = {
                                visual: '0771- 655 655',
                                link: '+46771655655',
                            };
                        } else {
                            iimclient.texts['call-number'] = {
                                visual: '0771- 655 655',
                                link: '+46771655655',
                            };
                        }
                    }
                    if (
                        /\?secom/.test(myfullpath) ||
                        /\?secombroker/.test(myfullpath) ||
                        /\?secomclaims/.test(myfullpath) ||
                        /\?secommotorclaims/.test(myfullpath)
                    ) {
                        if (/\?secombroker/.test(myfullpath)) {
                            iimclient.texts['call-number'] = {
                                visual: '0771-79 00 50',
                                link: '+46771790050',
                            };
                        } else if (
                            /\?secomclaims/.test(myfullpath) ||
                            /\?secommotorclaims/.test(myfullpath)
                        ) {
                            iimclient.texts['call-number'] = {
                                visual: '0771-815 818',
                                link: '+46771815818',
                            };
                        } else {
                            //secom
                            iimclient.texts['call-number'] = {
                                visual: '0771-56 00 00',
                                link: '+46771560000',
                            };
                        }
                    }
                } else if (iimclient.lang === 'lang_dk') {
                    iimclient.texts['call-number'] = {
                        visual: '70 12 12 12',
                        link: '+4570121212',
                    };
                    if (/\?dkcom/.test(myfullpath)) {
                        iimclient.texts['call-number'] = {
                            visual: '70 12 12 22',
                            link: '+4570121222',
                        };
                    } else if (/\?dkkvalitet/.test(myfullpath)) {
                        if (iimclient.phoneNumber)
                            iimclient.texts['call-number'] = {
                                visual: iimclient.phoneNumber,
                                link: '+45' + iimclient.phoneNumber.split(' ').join(''),
                            };
                        if (iimclient.phoneNumber2)
                            iimclient.texts['call-number2'] = {
                                visual: iimclient.phoneNumber2,
                                link: '+45' + iimclient.phoneNumber2.split(' ').join(''),
                            };
                    } else {
                        // dkpriv + dkprivwebshop
                        if (iimclient.phoneNumber)
                            iimclient.texts['call-number'] = {
                                visual: iimclient.phoneNumber,
                                link: '+45' + iimclient.phoneNumber.split(' ').join(''),
                            };
                        iimclient.texts['meeting-box-html'] =
                            '<div class="meetingbox"><p id="meeting-description"><span class="heading">Book møde</span></p><a class="if button secondary u-margin-top--16 meetingStarterBtn" role="button" href="https://www.if.dk/privat/kontakt/book-mode">Vælg mødeform</a></div>';
                    }
                } else if (iimclient.lang === 'lang_fi') {
                    iimclient.texts['call-number'] = {
                        visual: '10 19 19 19',
                        link: '+35810191919',
                    };
                } else if (iimclient.lang === 'lang_no' && /\?nopriv/.test(myfullpath)) {
                    iimclient.texts['meeting-box-html'] =
                        '<div class="meetingbox"><p id="meeting-description"><span class="heading">Trenger du rådgivning?</span></p><a class="if button secondary u-margin-top--16 meetingStarterBtn" role="button" href="https://www.if.no/privat/kundeservice/kontakt-oss/bestill-telefonmote" onclick="document.querySelector(\'.tooltip-close\').click();">Bestill her</a></div>';
                } else if (iimclient.lang === 'lang_en') {
                    iimclient.texts['call-number'] = {
                        visual: '21 49 24 00',
                        link: '+4721492400',
                    };
                    iimclient.texts['call-callback-description'] =
                        'We call you back regarding questions related to your insurances, except claims. Regarding claims, please call <br /><a class="styleless" href="tel:+4721492400" role="link">21 49 24 00</a> or <a class="styleless" href="https://www.if.no/privat/kundeservice/skriv-til-oss/omskade" role="link" target="_blank">write to us</a>.';
                }

                if (iimclient.configTexts && iimclient.texts) {
                    // Texts from config that will override or add to the above iimclient.texts
                    for (const key in iimclient.configTexts) {
                        if (Object.prototype.hasOwnProperty.call(iimclient.configTexts, key)) {
                            iimclient.texts[key] = iimclient.configTexts[key];
                        }
                    }
                }

                // const date = iimclient.now.getUTCDate();
                // const month = iimclient.now.getUTCMonth();
                // const year = iimclient.now.getUTCFullYear();

                if (iimclient.segment) {
                    if (iimclient.segment.floater_email_claimurl)
                        minimizeFloaterForURLs.push(iimclient.segment.floater_email_claimurl);
                    if (iimclient.segment.floater_email_otherurl)
                        minimizeFloaterForURLs.push(iimclient.segment.floater_email_otherurl);
                    iimclient.phoneVisualQueueId = iimclient.segment.floater_avgwaitingtimequeue;
                    iimclient.customerKey = iimclient.segment.puzzel_customerkey;
                    // iimclient.chat_lang = iimclient.segment.puzzel_countrycode;
                    if (iimclient.segment.floater_icon_hideshow)
                        iimclient.texts['hideshow-icon-title'] =
                            iimclient.segment.floater_icon_hideshow;
                    if (iimclient.segment.floater_icon_phone)
                        iimclient.texts['call-icon-title'] = iimclient.segment.floater_icon_phone;
                    if (iimclient.segment.floater_icon_email)
                        iimclient.texts['email-icon-title'] = iimclient.segment.floater_icon_email;

                    if (iimclient.puzzel_countrycode) {
                        iimclient.lang = 'lang_' + iimclient.puzzel_countrycode.toLowerCase();
                        iimclient.textlang = 'lang_' + iimclient.puzzel_countrycode.toLowerCase();
                    }
                }

                if (new RegExp(minimizeFloaterForURLs.join('|'), 'i').test(window.location.href))
                    iimclient.minimizeFloaterForURL = true;

                const hasLoadedStyleSheet = (namePattern) => {
                    let hasLoaded = false;
                    document.querySelectorAll('link[rel="stylesheet"]').forEach((elem) => {
                        if (
                            elem.getAttribute('href') &&
                            elem.getAttribute('href').match(namePattern) &&
                            !hasLoaded
                        )
                            hasLoaded = true;
                    });
                    return hasLoaded;
                };

                const loadStyleSheet = (url, media) => {
                    const link = document.createElement('link');
                    link.rel = 'stylesheet';
                    link.href = url;
                    link.type = 'text/css';
                    if (media) link.media = media;
                    document.head.appendChild(link);
                };

                if (iimclient.webcallback && iimclient.webcallback.bindToID) {
                    if (!hasLoadedStyleSheet(new RegExp('csstop')))
                        loadStyleSheet(
                            'https://webshop.if.fi/web/shop/bundles/csstop?v=20180728155457'
                        );
                    if (!hasLoadedStyleSheet(new RegExp('csstablet')))
                        loadStyleSheet(
                            'https://webshop.if.fi/web/shop/bundles/csstablet?v=20180902215933',
                            'only screen and (max-width:980px)'
                        );
                    if (!hasLoadedStyleSheet(new RegExp('cssmobile')))
                        loadStyleSheet(
                            'https://webshop.if.fi/web/shop/bundles/cssmobile?v=20180902215933',
                            'only screen and (max-width:660px)'
                        );
                    if (!hasLoadedStyleSheet(new RegExp('global-css')))
                        loadStyleSheet(
                            'https://cdnsc.azureedge.net/resources/global-css.arc.min-sha2N5XNQ4kKKWeoWMFdsiIkgNS_Fyo.css'
                        );
                    if (!hasLoadedStyleSheet(new RegExp('callbackform2018')))
                        loadStyleSheet(iimclient.mypath + '/callbackform2018.css');
                }

                if (new RegExp(hideCallbackForURLs.join('|'), 'i').test(window.location.href)) {
                    iimclient.hideCallbackStartBtn = true;
                }

                // based on jQuery.getScript implementation
                const loadScriptIfNot = function (expr, path, cb) {
                    if (expr !== undefined && expr !== false) return cb();
                    const head =
                        document.getElementsByTagName('body')[0] || document.documentElement;
                    let done = false;
                    const script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.async = true;
                    script.src = path;
                    script.onload = script.onreadystatechange = function () {
                        if (
                            !done &&
                            (!this.readyState ||
                                this.readyState === 'loaded' ||
                                this.readyState === 'complete')
                        ) {
                            done = true;
                            // Handle memory leak in IE
                            script.onload = script.onreadystatechange = null;
                            if (head && script.parentNode) {
                                head.removeChild(script);
                            }
                            cb();
                        }
                    };
                    // Use insertBefore instead of appendChild  to circumvent an IE6 bug.
                    // This arises when a base node is used (#2709 and #4378).
                    //head.insertBefore( script, head.firstChild );
                    head.appendChild(script);
                };

                const loadJQuery = function (cb) {
                    if (typeof $ !== 'undefined' && typeof jQuery !== 'undefined') return cb();
                    const div = document.createElement('div');
                    div.innerHTML = '<!--[if lt IE 9]><i></i><![endif]-->';
                    const isIeLessThan9 = div.getElementsByTagName('i').length == 1;
                    if (isIeLessThan9) {
                        return loadScriptIfNot(
                            false,
                            'https://chat.puzzel.com/Content/Client/js/jquery-1.11.2.min.js',
                            cb
                        );
                    } else {
                        return loadScriptIfNot(
                            false,
                            'https://chat.puzzel.com/Content/Client/js/jquery-latest.min.js',
                            cb
                        );
                        // return loadScriptIfNot(false, "https://ajax.googleapis.com/ajax/libs/jquery/1.12.2/jquery.min.js", cb);
                    }
                };

                const loadCallbackContentIfNeeded = function (cb) {
                    if (!iimclient.webcallback || !iimclient.webcallback.bindToID) {
                        return cb();
                    }

                    loadJQuery(function () {
                        const _loadSelect2 = function (icb) {
                            if (typeof $ === 'undefined' || typeof jQuery === 'undefined') {
                                console.log('jquery is undefined.. Skipping load of select2');
                                return cb();
                            }
                            const div = document.createElement('div');
                            div.innerHTML = '<!--[if lt IE 9]><i></i><![endif]-->';
                            const isIeLessThan9 = div.getElementsByTagName('i').length == 1;
                            if (isIeLessThan9) {
                                return loadScriptIfNot(
                                    false,
                                    'https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.12/js/select2.min.js',
                                    icb
                                );
                            } else {
                                return loadScriptIfNot(
                                    false,
                                    'https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.12/js/select2.min.js',
                                    icb
                                );
                            }
                        };

                        _loadSelect2(() => {
                            axios({
                                method: 'get',
                                url: iimclient.mypath + 'callbackform2018.html',
                            })
                                .then((res) => {
                                    $('#' + iimclient.webcallback.bindToID).html(res.data);
                                    console.log('Loaded callbackform2018');
                                    cb();
                                })
                                .catch((error) => {
                                    console.log('' + error.response.data);
                                    cb();
                                });
                        });
                    });
                };

                const init = function () {
                    loadCallbackContentIfNeeded(function () {
                        showPanel();
                    });
                };

                applyMobilityStyles();
                applyToggles(init);
            };

            if (!iimclient.useSegment) {
                loadIFHelp();
                return false;
            }
            ifhelp2015api.getSegment(iimclient.segmentId, function (err, segment) {
                if (err) {
                    console.log('' + err);
                    return;
                }

                if (segment) {
                    iimclient.segment = segment;

                    iimclient.lang = 'lang_' + iimclient.segment.language;
                    iimclient.textlang = iimclient.lang;

                    // we use the manual schedule if it is set
                    if (iimclient.segment.opening_schedule) {
                        loadIFHelp();
                        return false;
                    }
                    ifhelp2015api.getSchedule(
                        iimclient.segment.cbsegmentid,
                        function (err, schedule) {
                            if (err) {
                                console.log('' + err);
                                return;
                            }
                            iimclient.schedule = schedule;
                            loadIFHelp();
                        }
                    );
                }
            });
        });
    }
};

ifhelp2015api
    .featureTogglePromise('ShowIfGPT')
    .then(() => {
        if (!showIfGPT()) ifhelp();
    })
    .catch(ifhelp);
